import {
    // FILE_UPLOAD,
    CREATE_ARCSUPPORTTICKETS,
    RETRIEVE_ARCSUPPORTTICKETS,
    UPDATE_ARCSUPPORTTICKETS,
    DELETE_ARCSUPPORTTICKETS,
} from "./type";
import ARCSupportTickets from "../service/arcSupportTickets";
// export const fileUpload = (data) => async (dispatch) => {
//   try {
//     const res = await ARCSupportTickets.fileUpload(data);
//     dispatch({
//       type: FILE_UPLOAD,
//       payload: res.data.data,
//     });
//     return Promise.resolve(res.data);
//   } catch (err) {
//     return Promise.reject(err);
//   }
// };
export const create = (data) => async (dispatch) => {
    try {
        const res = await ARCSupportTickets.create(data);
        dispatch({
            type: CREATE_ARCSUPPORTTICKETS,
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const retrieveAdmin = (data) => async (dispatch) => {
    try {
        const res = await ARCSupportTickets.fetchAdminList(data);
        dispatch({
            type: RETRIEVE_ARCSUPPORTTICKETS,
            status: '',
            response: {},
            payload: res.data.data,
        });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const retrieveStaff = (data) => async (dispatch) => {
    try {
        const res = await ARCSupportTickets.fetchStaffList(data);
        dispatch({
            type: RETRIEVE_ARCSUPPORTTICKETS,
            status: '',
            response: {},
            payload: res.data.data,
        });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const retrieveServiceUser = (data) => async (dispatch) => {
    try {
        const res = await ARCSupportTickets.fetchServiceUserList(data);
        dispatch({
            type: RETRIEVE_ARCSUPPORTTICKETS,
            status: '',
            response: {},
            payload: res.data.data,
        });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const retrieveSingle = (data) => async (dispatch) => {
    try {
        const res = await ARCSupportTickets.fetchSingle(data);
        // dispatch({
        //     type: RETRIEVESINGLE_ARCSUPPORTTICKETS,
        //     status: '',
        //     response: {},
        //     payload: res.data.data,
        // });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const update = (data) => async (dispatch) => {
    try {
        const res = await ARCSupportTickets.update(data);
        dispatch({
            type: UPDATE_ARCSUPPORTTICKETS,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
// export const changeStatus = (data) => async (dispatch) => {
//     try {
//         const res = await ARCSupportTickets.changeStatus(data);
//         dispatch({
//             type: UPDATE_ARCSUPPORTTICKETS,
//             status: '',
//             response: {},
//             payload: res.data,
//         });
//         return Promise.resolve(res.data);
//     } catch (err) {
//         return Promise.reject(err);
//     }
// };
export const trash = (data) => async (dispatch) => {
    try {
        const res = await ARCSupportTickets.trash(data);
        dispatch({
            type: DELETE_ARCSUPPORTTICKETS,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};